module.exports = __webpack_public_path__ + "static/media/orogel-512.527718a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/orogel-512.png
// module id = 777
// module chunks = 0